export default __webpack_public_path__ + "static/drawing-6d56a7bc218bf62663f81e25c0d5ed95.png";